import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { useThemeService } from '../../../data/services';

const useStyles = makeStyles({
    scrollbar: {
        scrollbarWidth: 'thin',
        // Firefox
        scrollbarColor: `${tokens.colorNeutralForeground4} ${tokens.colorNeutralBackground2}`,

        // Chromium / Edge / Safari
        '&::-webkit-scrollbar': {
            width: '8px',
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: tokens.colorNeutralBackground2,
            borderRadius: '8px',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: tokens.colorNeutralForeground4,
            borderRadius: '8px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: tokens.colorNeutralForeground3,
        },
    },    
});

export const useScrollbarClasses = () => {

    const styles = useStyles();

    return {
        classes: {
            scrollbarClasses: mergeClasses(
                styles.scrollbar,
            )
        }
    };
};
